import { useLang } from '@/i18n';
import css from './index.module.scss';
import { useEffect, useState } from 'react';

const L: React.FC = () => {
    const { t } = useLang('stream_ultra_x');
    const [load, setLoad] = useState(false);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const sceneL = AniContainer.create({
                triggerElement: '.stream-ultra-x-G',
                triggerHook: 1,
                onEnter: () => setLoad(true),
            });
            return () => {
                sceneL.destroy();
            };
        }
    }, []);

    return (
        <section
            className={`${css.section} stream-ultra-x-L GtmModuleData-section`}
            id="stream-ultra-x-L"
            data-section-id={'stream-ultra-x-L'}
            data-section-title={t('L_title')}
        >
            <div className="info">
                <p className="title">{t('L_title')}</p>
                <p className="desc">{t('L_desc')}</p>
            </div>
            <div className="video">
                {load && (
                    <video
                        src="https://websiteoss.ecoflow.com/upload/video/1753674977110/12.mp4"
                        poster="https://websiteoss.ecoflow.com/upload/image/1754399120475/12-pc.jpg"
                        loop
                        autoPlay
                        muted
                        width="100%"
                        height="100%"
                        playsInline
                        preload="auto"
                        aria-label={t('L_title')}
                    />
                )}
            </div>
        </section>
    );
};

export default L;
